export default 'checkout-page-clone';
